import { z } from 'zod';

import { StoryModuleFragment } from '../graphql/generated/graphql';
import { ValidationError } from '../utils/errors';

export const ProductSchema = z
  .object({
    __typename: z.literal('Products'),
    Slug: z.string(),
  })
  .passthrough();

export type Product = StoryModuleFragment['Product'] &
  z.infer<typeof ProductSchema>;

export const isProduct = (
  product: unknown,
  strict = true
): product is Product => {
  const result = ProductSchema.safeParse(product);
  if (strict && !result.success) {
    throw new ValidationError(
      `Invalid product: ${JSON.stringify(product)}` +
        '\n' +
        `Issues: ${JSON.stringify(result.error.issues)}`
    );
  }
  return result.success;
};
